import { EligibleModule } from '../pages/eligible-modules/types';
import { APP_URLS } from '../routes/urls';

const storeGuestUserEmail = (email: string): void => {
  localStorage.setItem('guest_email', email);
};

const deleteGuestUserEmail = (): void => {
  localStorage.removeItem('guest_email');
};

export const getGuestUserEmail = (): string | null => {
  return localStorage.getItem('guest_email');
};

export const updateGuestUserEmail = (email?: string | null): void => {
  if (email) {
    storeGuestUserEmail(email);
  } else {
    deleteGuestUserEmail();
  }
};

export const getEligibleModuleUrl = (module?: EligibleModule | null): string => {
  switch (module) {
    case 'Programs':
      return APP_URLS.eligiblePrograms;
    case 'Scholarships':
      return APP_URLS.eligibleScholarships;
    default:
      return APP_URLS.eligibleInstitutes;
  }
};
